//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CheckField from "../components/fields/check";
export default {
  components: {
    "fields-check": CheckField
  },
  props: {
    spec: {
      type: Object,
      required: true
    },
    responsiveCols: {
      type: Number,
      "default": function _default() {
        return 0;
      }
    }
  },
  data: function data() {
    return {
      accessory: {},
      editButtons: [] // checkSpec: null

    };
  },
  computed: {
    clickCondition: function clickCondition() {
      if (this.spec.onClick || this.spec.onLongPress) {
        // This will show the clickable indication
        return "click";
      }

      return null;
    },
    // Implemented as computed so that it gets reflected when reordering
    chips: function chips() {
      var _this = this;

      return (this.spec.chips || []).map(function (item) {
        var color = null;

        _this.$type.ifArray(item.styleClasses, function (classes) {
          for (var _i = 0, _arr = ["success", "info", "warning", "error"]; _i < _arr.length; _i++) {
            var val = _arr[_i];

            if (classes.includes(val)) {
              color = val;
            }
          }
        });

        return Object.assign({}, item, {
          color: color,
          view: "chip"
        });
      });
    },
    // Implemented as computed so that it gets reflected when navigating to another list containing check fields.
    checkSpec: function checkSpec() {
      if (this.spec.fieldCheckName) {
        return {
          view: "fields/checkGroup",
          name: this.spec.fieldCheckName,
          checkValue: true,
          valueIf: this.spec.fieldCheckValueIf,
          padding: {
            left: 16
          }
        };
      }

      return null;
    }
  },
  methods: {
    $ready: function $ready() {
      this.accessory = {
        childViews: this.spec.accessoryViews
      };
      this.editButtons = this.spec.editButtons || [];
    },
    buttonSpec: function buttonSpec(item) {
      return Object.assign({}, item, {
        view: "button-v1",
        styleClasses: item.text ? ["text"] : ["icon"]
      });
    },
    columnStyles: function columnStyles() {
      if (this.responsiveCols) {
        return "width: ".concat(100 / this.responsiveCols, "%; float: left;");
      }
    }
  }
};